import { render } from "./pestel_step_one.vue?vue&type=template&id=79e30ea6&scoped=true"
import script from "./pestel_step_one.vue?vue&type=script&lang=js"
export * from "./pestel_step_one.vue?vue&type=script&lang=js"

import "./pestel_step_one.vue?vue&type=style&index=0&id=79e30ea6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e30ea6"]])

export default __exports__